import $ from "jquery";
import { ManualSpinCustomization } from "./customize_manualspin.js";
import { AutoSpinCustomization } from "./customize_autospin.js";
import { InstructionCustomization } from "./customize_instruction.js";

// ZOOM
class ZoomCustomization {
    constructor() {
        // Zoom on/off instant update (checkbox)
        $('[name="variant[enable_zoom]"]').change(function () {
            if (this.checked || this.value === "true") {
                viewer().zoom(true)
                if ($('[name="variant[zoom_ratio]"]:checked').length > 0) {
                    $('[name="variant[zoom_ratio]"]:checked').trigger('change')
                }
            } else {
                viewer().zoom(false)
            }
        })

        // Zoom ratio instant update
        $('[name="variant[zoom_ratio]"]').change(function () {
            viewer().zoom_ratio(parseFloat(this.value))
        })

        // Zoom speed instant update
        $('[name="variant[zoom_speed]"]').change(function () {
            viewer().zoom_speed(parseFloat(this.value))
        })

        // Zoom speed instant update
        $('[name="variant[zoom_image_interpolation]"]').change(function () {
            viewer().zoom_image_interpolation(this.value === "true")
        })
    }
}


// STARTING FRAME
class StartingFrameCustomization {
    constructor() {

        // Starting frame instant update
        $('[name="variant[key_image]"]').change(function () {
            viewer().key_image(parseInt(this.value))
        })

        $('#key_image_current_frame').on('click', function () {
            const key_image = viewer().ordial ? viewer().ordial : viewer().index;
            if (key_image > viewer().settings.total) {
                alert("Maximum numebr of available frames and stills exceeded.")
            } else {
                $('[name="variant[key_image]"]').val(`${key_image}`)
                viewer().key_image(key_image)
            }
            return false
        })

        // Loading behavior
        $('[name="variant[load_on]"]').change(function () {
            viewer().load_on(this.value)
            if ((this.value === "click") || (this.value === "hover")) {
                $('[name="variant[spin_controls_size]"]').removeAttr('disabled')
            } else {
                $('[name="variant[spin_controls_size]"]').attr('disabled', true)
            }
        })

        // Quality
        $('[name="variant[quality]"]').change(function () {
            viewer().quality(parseInt(this.value))
        })

        // Chunk size
        $('[name="variant[chunk_size]"]').change(function () {
            viewer().chunk_size(parseInt(this.value))
        })

        // Loading indicator instant update
        $('[name="variant[enable_loading_indicator]"]').change(function () {
            if (this.value === "true") {
                viewer().loading_indicator(true)
            } else {
                viewer().loading_indicator(false)
            }
        })

        // Spin controls size instant update
        $('[name="variant[spin_controls_size]"]').change(function () {
            viewer().spin_controls_size(parseFloat(this.value))
        })
    }
}


// FOOTER

class FooterCustomization {
    constructor() {
        // Footer background color instant update
        $('[name="variant[footer_background_color]"]').change(function () {
            viewer().dock_background_color(this.value)
        })

        // Footer background gradient instant update
        const backgroundGradient = $('[name="variant[footer_background_gradient]"]')
        const backgroundGradientSlider = $('#footer_background_gradient_slider')

        backgroundGradient.on('input', function () {
            viewer().dock_background_gradient(parseFloat(this.value))
            backgroundGradientSlider.val(this.value)
        })

        backgroundGradientSlider.on('input', function () {
            backgroundGradient.val(this.value)
            viewer().dock_background_gradient(parseFloat(this.value))
        })

        // Footer thumb rounded corners instant update
        const roundedCorners = $('[name="variant[footer_thumb_rounded_corners]"]')
        const roundedCornersSlider = $('#footer_thumb_rounded_corners_slider')

        roundedCorners.on('input', function () {
            viewer().dock_thumbs_border_radius(parseFloat(this.value))
            roundedCornersSlider.val(this.value)
        })

        roundedCornersSlider.on('input', function () {
            roundedCorners.val(this.value)
            viewer().dock_thumbs_border_radius(parseFloat(this.value))
        })

        roundedCorners.on('change', function () {
            viewer().dock_thumbs_border_radius(this.value === "true")
        })

        // Extra views order instant update
        $('[name="variant[reverse_extra_views]"]').change(function () {
            viewer().reverse_thumbs(this.value === "true")
        })

        // Thumb interaction instant update
        $('[name="variant[thumb_interaction]"]').change(function () {
            viewer().dock_thumb_interaction(this.value)
        })
    }
}

class FullscreenCustomization {
    constructor() {
        // FULLSCREEN

        // Fullscreen on/off instant update (checkbox)
        $('[name="variant[fullscreen]"]').change(function () {
            const isEnabled = this.checked || this.value === "true"
            if (viewer().enable_fullscreen) {
                viewer().enable_fullscreen(isEnabled)
            } else {
                viewer().fullscreen(isEnabled)
            }
        })

        // Fullscreen icon variant instant update
        $('[name="variant[fullscreen_icon_variant]"]').change(function () {
            viewer().fullscreen_icon_variant(this.value)
        })

        // Fullscreen icon position instant update
        $('[name="variant[fullscreen_icon_position]"]').change(function () {
            viewer().fullscreen_icon_position(this.value)
        })

        // Fullscreen icon size instant update
        $('[name="variant[fullscreen_icon_size]"]').change(function () {
            viewer().fullscreen_icon_size(parseFloat(this.value))
        })
    }
}

class BackgroundCustomization {
    constructor() {
        const preview = $('#preview')
        const backgroundColor = $('[name="variant[background_color]"]')
        const transparent = $('#background_color_transparent')

        // Background color instant update
        backgroundColor.change(function () {
            let colorValue = this.value;
            // Add # prefix for viewer if it's a hex color (not transparent)
            if (colorValue !== 'transparent' && colorValue && !colorValue.startsWith('#')) {
                colorValue = '#' + colorValue;
            }
            
            viewer().background_color(colorValue)
            if (colorValue !== 'transparent') {
                preview.css({'background-color': colorValue})
                transparent.prop('checked', false)
            } else {
                preview.css({'background-color': "none"})
            }
        })

        backgroundColor.blur(function () {
            let colorValue = this.value;
            // Add # prefix for viewer if it's a hex color (not transparent)
            if (colorValue !== 'transparent' && colorValue && !colorValue.startsWith('#')) {
                colorValue = '#' + colorValue;
            }
            
            if (backgroundColor.val() === 'transparent') {
                preview.addClass("chessboard")
            } else {
                preview.removeClass("chessboard")
            }
            viewer().background_color(colorValue)
        })

        // Initially update transparent checkbox
        if (backgroundColor.val() === 'transparent') {
            transparent.prop('checked', true)
            preview.addClass("chessboard")
            // Disable color picker initially if transparent
            $('#background_color_picker').prop('disabled', true)
        }

        // Background color transparent
        transparent.on('change', function () {
            if (transparent.is(':checked')) {
                backgroundColor.val('transparent').trigger('change')
                preview.addClass("chessboard")
                // Disable and clear color picker when transparent is checked
                $('#background_color_picker').prop('disabled', true).val('#ffffff')
            } else {
                backgroundColor.val('ffffff').trigger('change')
                preview.removeClass("chessboard")
                // Enable color picker when transparent is unchecked
                $('#background_color_picker').prop('disabled', false)
            }
        })
    }
}


class GeneralCustomization {
    constructor() {
        let that = this

        // Preload images if requested via data attribute
        $('[data-preload]').on('click', function () {
            return $($(this).data('preload').split(',')).preload()
        })

        $('input, select, textarea').on('change', () => window.changed = true)

        // Initialize HTML5 color pickers
        $('input[type="color"]').each(function() {
            const colorPicker = $(this);
            const textField = colorPicker.closest('.row').find('input[type="text"]');
            
            if (textField.length > 0) {
                // Sync color picker with text field
                colorPicker.on('change', function() {
                    const color = this.value;
                    // Remove # prefix for text field (since we have # in input group)
                    const hexColor = color.startsWith('#') ? color.substring(1) : color;
                    textField.val(hexColor).trigger('change');
                    
                    // Uncheck transparent checkbox when color is selected
                    $('#background_color_transparent').prop('checked', false);
                });

                // Sync text field with color picker
                textField.on('input', function() {
                    const color = this.value;
                    // Check if it's a valid hex color (without # since we have # in input group)
                    if (color && color !== 'transparent' && /^[a-fA-F0-9]{6}$/.test(color)) {
                        // Add # prefix for color picker
                        const hexColor = '#' + color;
                        colorPicker.val(hexColor);
                        
                        // Uncheck transparent checkbox when valid color is entered
                        $('#background_color_transparent').prop('checked', false);
                    }
                });
            }
        });

        // Adjust the initial status of all on/off switches
        $('#variant-customize .indicator input').each(function () {
            that.adjustOnOff($(this))
        })

        // Enable / disable setting if the ON or OFF buttons are clicked
        $('#variant-customize .indicator').on('click', function (e) {
            let input = $(this).find('input')
            let sectionHeader = $(this).closest('.customize-section-header')
            let header = sectionHeader.find('[data-bs-toggle="collapse"]')
            let targetSelector = header.attr('data-bs-target')
            let collapse = targetSelector ? $(targetSelector) : null

            if (input.val() === "true") {
                // Currently ON - switch to OFF and close collapse
                input.val("false").trigger('change')
                if (collapse && collapse.hasClass('show')) {
                    header.trigger('click')
                }
            } else {
                // Currently OFF - switch to ON and open collapse
                input.val("true").trigger('change')
                if (collapse && !collapse.hasClass('show')) {
                    header.trigger('click')
                }
            }
            that.adjustOnOff(input)
        })
    }

    adjustOnOff(input) {
        if (input.val() === "true") {
            input.parent().find('.enabled').show()
            input.parent().find('.disabled').hide()
        } else {
            input.parent().find('.enabled').hide()
            input.parent().find('.disabled').show()
        }
    }
}


function customize_init() {
    new GeneralCustomization()
    new ManualSpinCustomization()
    new AutoSpinCustomization()
    new InstructionCustomization()
    new ZoomCustomization()
    new StartingFrameCustomization()
    new FooterCustomization()
    new FullscreenCustomization()
    new BackgroundCustomization()
}

// Make customize_init globally available
window.customize_init = customize_init;

document.addEventListener('turbo:frame-load', function() {
  // For each customize section header
  document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function(header) {
    var chevron = header.querySelector('.chevron-toggle');
    var targetSelector = header.getAttribute('data-bs-target');
    if (!targetSelector) return;
    var collapse = document.querySelector(targetSelector);
    if (!collapse) return;
    // Initial state
    var sectionHeader = header.closest('.customize-section-header');
    if (collapse.classList.contains('show')) {
      if (chevron) chevron.classList.add('chevron-rotated');
      if (sectionHeader) sectionHeader.classList.add('active');
    } else {
      if (chevron) chevron.classList.remove('chevron-rotated');
      if (sectionHeader) sectionHeader.classList.remove('active');
    }
    // Listen for collapse events
    collapse.addEventListener('show.bs.collapse', function() {
      if (chevron) chevron.classList.add('chevron-rotated');
      if (sectionHeader) sectionHeader.classList.add('active');
      // Set ON/OFF toggle to ON when section is expanded
      var indicatorInput = sectionHeader ? sectionHeader.querySelector('.indicator input') : null;
      if (indicatorInput && indicatorInput.value !== 'true') {
        indicatorInput.value = 'true';
        indicatorInput.dispatchEvent(new Event('change', { bubbles: true }));
        // Update the visual ON/OFF display
        var indicator = indicatorInput.parentElement;
        var enabledText = indicator.querySelector('.enabled');
        var disabledText = indicator.querySelector('.disabled');
        if (enabledText) enabledText.style.display = '';
        if (disabledText) disabledText.style.display = 'none';
      }
    });
    collapse.addEventListener('hide.bs.collapse', function() {
      if (chevron) chevron.classList.remove('chevron-rotated');
      if (sectionHeader) sectionHeader.classList.remove('active');
    });
  });
});
